import Vue from 'vue';
import BifrostNumber from '@bifrost-platform/bifrost-number';

Vue.prototype.$BBN = BifrostNumber;

export default BifrostNumber;
